export function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function waitFor<T>(
  checkFn: () => T | undefined | null,
  interval: number = 25
): Promise<T> {
  return new Promise<T>((resolve) => {
    const check = () => {
      const result = checkFn()
      if (result) {
        resolve(result)
      } else {
        setTimeout(check, interval)
      }
    }
    check()
  })
}